import React from 'react';
import { StatusMark } from '../../../components/StatusMark';
import { useTranslation } from '../../../i18n';

/** 收藏里的邀约接受状态。3 已接受，4 未接受，5 已出单。 */
export function CreatorAcceptTag({ label }: { label?: number | null }) {
  const { t } = useTranslation();
  if (label === 3) {
    return <StatusMark tone='success'>{t('invitation.label_accepted')}</StatusMark>;
  }
  if (label === 4) {
    return <StatusMark tone='muted'>{t('invitation.label_unaccepted')}</StatusMark>;
  }
  if (label === 5) {
    return <StatusMark tone='review'>{t('invitation.label_ordered')}</StatusMark>;
  }
  return null;
}
